module.exports = __webpack_public_path__ + "static/work_icon_research-6eee34bea631e1c6a35d4823dc7a2bf6.png";